import React from 'react';
import { CreateDocumentsForm } from 'modules/components/layer12';
import { BasicFormModalLayout } from 'modules/components/layer13';
import { useParams } from 'react-router-dom';

export type CreateDocumentsModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: CreateDocumentsModalProps) => {
  const params = useParams();
  const projectId = params.projectId;
  const folderId = params.folderId;

  return (
    <BasicFormModalLayout.FC
      id={props.id}
      title='Upload Documents'
      subTitle='Enter details in order to save your documents to the system.'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
    >
      <CreateDocumentsForm.FC
        projectId={projectId}
        folderId={folderId}
        id={props.id}
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );

};
